export default __webpack_public_path__ + "static/media/ProfileNav.5961d689.svg";